module.exports = __webpack_public_path__ + "static/img/no-data.57626ca6.png";